export const ACCOUNT_TYPES = {
  COMPANY: 'Company',
  PRODUCER: 'Producer',
  CREW: 'Crew'
};
